import "core-js/modules/es6.array.filter";
import _get from "lodash/get";
import _isEqual from "lodash/isEqual";
import { getNextTransactionsPage, getTransactions, updateTransactionsViewList } from "../actions/yodlee";
import { getTransactionData, getTransactionsResultsSetToken } from "../selectors"; // This middleware ensures that the underlying transactions
// in the store are opaque to consumers. If we have the necessary
// transactions to get the next page already in the store, then
// we simply append them to the viewList (done in the reducer)
// otherwise, we make a request to get more transactions from identity.

export default (function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      var result = next(action);
      var viewFilter = getState().identity.yodlee.transactions.viewFilter; // If a request has completed (and it's not bulk request) then update
      // the view list

      if (action.type === getTransactions.SUCCESS_TYPE && !action.meta.bulkData) {
        // Make sure that this is for the current filter
        if (_isEqual(viewFilter, action.meta.filter || {})) {
          dispatch(updateTransactionsViewList());
        }

        return result;
      }

      if (action.type !== getNextTransactionsPage.getType()) {
        return result;
      }

      var state = getState();
      var transactionData = getTransactionData(state.identity, viewFilter);
      var visibleCount = getState().identity.yodlee.transactions.viewList.length;
      var limit = action.payload.limit; // If we don't have this transactionData in the store at all then request
      // transactions

      if (!transactionData || transactionData.needsRefresh) {
        dispatch(getTransactions({
          offset: visibleCount,
          limit: limit,
          filter: viewFilter,
          resultsSetToken: getTransactionsResultsSetToken(state.identity),
          shouldReset: transactionData && transactionData.needsRefresh,
          includeDisabledAccounts: !!_get(viewFilter, 'accountId')
        }));
        return result;
      } // If we don't have the necessary transactions already in the store
      // then request transactions.


      var transactions = transactionData.transactions;

      if (!transactionData.lastPageReached && transactions.length < visibleCount + limit) {
        dispatch(getTransactions({
          offset: transactionData.transactions.length,
          // Only request as many as we need using limit
          limit: limit - (transactionData.transactions.length - visibleCount),
          filter: viewFilter,
          resultsSetToken: getTransactionsResultsSetToken(state.identity),
          includeDisabledAccounts: !!_get(viewFilter, 'accountId')
        }));
        return result;
      } // Otherwise we must already have transactions so just update the view list


      dispatch(updateTransactionsViewList(visibleCount + limit));
      return result;
    };
  };
});